const { addMonths, setDay } = require("date-fns");

/**
 * A Web Component for making a VBC selection
 * Usage: <vbc-selection data-subscription={{subscription.id}} data-product={{ product.id }}"></vbc-selection>
 */
export default class VbcSelection extends HTMLElement {
  constructor() {
    super();

    this.error = false;

    this.loadingOverlay = document.getElementById(
      "vbc-selection-loading-overlay",
    );
    this.selectionInterface = document.getElementById(
      "vbc-selection-interface",
    );

    this.fetchInitialState();
    this.bindButtonClick();
  }

  get orderDate() {
    if (this.subscription.is_prepaid) {
      const date = new Date();
      let nextMonth = addMonths(date, 1);
      nextMonth = setDay(nextMonth, this.subscription.order_day_of_month || 1);
      return nextMonth.toISOString();
    } else {
      return this.subscription.next_charge_scheduled_at;
    }
  }

  get subscription() {
    return window.ReCharge.Novum.subscription;
  }

  get subscriptionId() {
    return this.subscription.id;
  }

  get selectButtons() {
    return [...this.querySelectorAll('[name="select"]')];
  }

  hideLoading() {
    this.loadingOverlay.classList.add("hidden");
    this.selectionInterface.classList.remove("hidden");
  }

  fetchInitialState() {
    const path =
      "/apps/verso/vbc_selection?" +
      new URLSearchParams({
        subscription_id: this.subscriptionId,
        order_date: this.orderDate,
      });

    fetch(path, this.fetchConfig("GET"))
      .then((response) => response.json())
      .then((data) => {
        this.updateVisibleSelection(data);
        this.hideLoading();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  bindButtonClick() {
    this.selectButtons.forEach((button) => {
      button.addEventListener("click", this.handleButtonClick);
    });
  }

  findButtonByProductId(productId) {
    return this.selectButtons.find(
      (button) => productId === Number(button.dataset.product),
    );
  }

  fetchConfig(method = "POST") {
    return {
      method,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
  }

  updateVisibleSelection(data) {
    const productId = data?.shopify_product_id;
    const selectedButton = this.findButtonByProductId(productId);

    this.selectButtons.forEach((button) =>
      button === selectedButton
        ? this.buttonSelect(button)
        : this.buttonUnselect(button),
    );
  }

  buttonSelect(button) {
    button.innerHTML = "Current Selection";
    button.setAttribute("aria-disabled", "true");
    button.hidden = false;
  }

  buttonUnselect(button) {
    button.innerHTML = "Select This Book";
    button.setAttribute("aria-disabled", "false");
    button.hidden = false;
  }

  recordSelection(productId, isbn) {
    const body = JSON.stringify({
      subscription_id: this.subscriptionId,
      order_date: this.orderDate,
      product_id: productId,
      isbn,
    });

    fetch(`/apps/verso/vbc_selection/`, { ...this.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((data) => {
        this.updateVisibleSelection(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleButtonClick = (event) => {
    const button = event.target;
    const productId = Number(button.dataset.product);
    const isbn = Number(button.dataset.isbn);

    if (button.getAttribute("aria-disabled") === "true") return;

    this.recordSelection(productId, isbn);
  };
}
